import { Field, Form, Formik } from "formik";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid, currentTenant } from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import { FormikTextField } from '../../CommonComponents/FormField.js';
import { Spinner } from "react-bootstrap";
import { Autocomplete } from "@mui/material";
import WarehouseServices from "../Warehouse/WarehouseServices.js";
import WorkCenterServices from "./WorkCenterServices.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";

class NewWorkCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      warehouseList: [],
      name: "",
      address: "",
      warehouse: "",
      whid: "",
      loader: false,
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  
  handleWarehouse = (e,values) => {
    if(typeof values !== 'object' || values === undefined ||values ==='' || values===null ){
      this.setState({ warehouse: '',whid:'',  });
    }else{  
    this.setState({ warehouse: values?.name,whid:values.id, });
    }
  };


  onSubmit(values) {
    this.setState({ loader: true });
    let data = {
      name: values.name,
      address: this.state.address,
      whid: this.state.whid,
      tenantid: currentTenant,
      createdby: userid,
    };
    WorkCenterServices.addWorkCenter(data)
      .then(() => this.props.navigate("/workcenter"))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }
    WarehouseServices.getWarehouses(currentTenant)
      .then((response) => {
        this.setState({ warehouseList: response.data });
      })
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      });
  }

  validate(values) {
    let errors = {};

    if (!values.name || values.name === "") {
      errors.name = "WorkCenter Name is Required";
    }
    if (!values.address || values.address === "") {
      errors.address = "WorkCenter Name is Required";
    }
    if (!values.warehouse || values.warehouse === "") {
      errors.warehouse = "Org Unit is Required";
    }
    return errors;
  }

  render() {
    let { id, name, warehouse, warehouseList, whid, address } = this.state;

    return (
      <div>
        <Header />
        <Menu />

        <div className="content-wrapper">
        <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/masters"},{name:"WorkCenter/Production",path:"/workcenter"},{name:"New WorkCenter/Production",path:null}]}/>
          </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{
                  id,
                  name,
                  warehouse,
                  warehouseList,
                  whid,
                  address,
                }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({ setFieldValue, values,errors }) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset hidden className="form-group col-md-6">
                        <label>Id</label>
                        <Field
                          className="form-control"
                          type="text"
                          name="id"
                          placeholder="Id"
                        />
                      </fieldset>

                      <fieldset className="form-group col-md-4">
                      <TextfieldComponent type="text" name="name" label="WorkCenter/Production Unit" onChange={(e)=>this.setState({name:e.target.value})} error={errors?.name} required/>
                      </fieldset>
                      <fieldset className="form-group col-md-4">
                        <TextfieldComponent type="text" name="address" label="WorkCenter/Production Unit Address" onChange={(e) => this.setState({ address: e.target.value })} error={errors?.address} required/>
                      </fieldset>
                      <fieldset className="form-group col-md-4">
                      <AutoCompeteField id="warehouse" name="warehouse" type="text" options={warehouseList} valueKey={"name"} labelKey={"name"} value={this.state.warehouse} label={`Select Org Unit`} placeholder="" onChange={this.handleWarehouse} required error={errors?.warehouse}/>
                      </fieldset>
                    </div>
                    <div className="form-group col-md-12 tw-flex tw-justify-end">
                    {this.state.loader === true ? (
                      <button className="UI-btn UI-btn-primary" disabled>
                        <Spinner animation="border" size="sm" />
                        &nbsp;{"Saving"}
                      </button>
                    ) : (
                      <button className="UI-btn UI-btn-primary" type="submit">
                        Save
                      </button>
                    )}
                    <Link
                      as="button"
                      className="UI-btn UI-btn-outline ml-1"
                      to={{ pathname: "/workcenter" }}
                    >Cancel</Link>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(NewWorkCenter);
